module.exports = __webpack_public_path__ + "static/media/enable_2fa.73601475.png";